import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import { Link } from "react-router";

import { ROUTE_PATHS } from "@/shared/constants/route-paths";

import { AuthAnimatedBackground } from "./auth-animated-background";

export function AuthLayout() {
  const { t } = useTranslation("common");

  return (
    <div className="auth-page relative h-svh overflow-hidden bg-background">
      <AuthAnimatedBackground />

      <div className="relative z-10 flex h-full min-h-0 flex-col overflow-y-auto">
        <main className="flex flex-1 flex-col items-center justify-center px-6 py-10">
          <Outlet />
        </main>

        <footer className="flex shrink-0 flex-col items-center gap-2 pb-6 text-sm text-muted-foreground">
          <div className="flex items-center gap-4">
            <Link
              to={ROUTE_PATHS.TERMS}
              className="transition-colors hover:text-foreground hover:underline"
            >
              {t("termsOfService")}
            </Link>
            <Link
              to={ROUTE_PATHS.PRIVACY}
              className="transition-colors hover:text-foreground hover:underline"
            >
              {t("privacyPolicy")}
            </Link>
          </div>
          <span className="text-xs">© 2018 - {new Date().getFullYear()} Sailwith</span>
        </footer>
      </div>
    </div>
  );
}
